import { ModelBase } from '../../core/model/model-base';
import {
  AdjustmentKind,
  ArticleUnit,
  ArticleTimeUnitKind,
  ArticleTimeUnitKindToString,
  AdjustmentKindToString,
  AppendixTypeKind,
} from './const/enums';
import { Account } from '../../accounting/model/account';

export class AppendixSection extends ModelBase {
  header: string;
  content: string;
  sortOrder: number;

  toString() {
    return this.header;
  }
}

export class Appendix extends ModelBase {
  constructor(context?: any) {
    super();
    if (context) {
      this.sections = Array.isArray(context.sections) ? context.sections : [];
    }
  }

  title: string;
  sortOrder: number;
  statusText: string;
  useForDwelling: boolean;
  useForParking: boolean;
  pageFooter: string;
  companyLogo: boolean;
  realEstateLevelUsage: boolean;
  appendixType: AppendixTypeKind;
  sections: AppendixSection[] = [];

  toString() {
    return this.title;
  }
}
